<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group  margin-0">
          <label class="col-sm-2 control-label">
            Reward Name
          </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="searchName" name="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <el-button type="primary" @click="search">{{
                $t("message.Search")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom:60px;">
              <div class="col-sm-12">
                <div class="pull-right">
                  <el-button
                    @click="gotoDetail"
                    v-if="checkPermission('REWARDS_LIST_ADD')"
                    >{{ $t("message.Add") }}</el-button>
                  <el-button
                    @click="showWarning"
                    v-if="checkPermission('REWARDS_LIST_DEL')"
                    >{{ $t("message.Delete") }}</el-button>
                </div>
              </div>
              <div class="col-xs-12">
                {{total}}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="rows"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                row-key="id"
                :cell-class-name="cell"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  label="Reward Name"
                  :show-overflow-tooltip="true"
                  min-width="200"
                >
                  <template slot-scope="scope">
                    <div>
                      <el-tag 
                        type="warning" 
                        effect="dark"
                        size="mini"
                        v-if="scope.row.expired"
                        >
                        Expired
                      </el-tag>
                      {{scope.row.name}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="inventory"
                  label="Qty in Public WH"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  prop="redemptionLimit"
                  label="Redemption Limit"
                  min-width="150"
                ></el-table-column>
                <el-table-column
                  prop="categoryNameEn"
                  label="Rewards Category"
                  min-width="150"
                ></el-table-column>
                <el-table-column
                  prop="statusName"
                  label="Status"
                  min-width="75"
                ></el-table-column>
                <el-table-column
                  prop="updatedAt"
                  label="Last Update Time"
                  width="170"
                >
                </el-table-column>
                <el-table-column
                  prop="updatedBy"
                  label="Last Update By"
                  width="170"
                >
                </el-table-column>
                <el-table-column
                  label="Action"
                  width="120"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="12" style="float:right" v-if=" canDrag">
                        <div class="text-center dragTip">=</div>
                      </el-col>

                      <el-col :span="12" style="float:right">
                       <el-button size="mini" @click="handleDbClick(scope.row)" icon="el-icon-edit" ></el-button>
                      </el-col>
                    </el-row>
                     
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination 
                   layout="total, sizes, prev, pager, next, jumper" 
                   @size-change="handleSizeChange" 
                   @current-change="handleCurrentChange" 
                   :page-sizes="[10, 20, 50, 100]" 
                   :page-size="pagesize" 
                   :total="total" 
                   style="float:right;">
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";
import Sortable from "sortablejs";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      name: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "ASC",
      sortField: "sortOrder",
      status: "",
      statusObj: [],
      typeObj:[],
      type:"",
      status:"",
      startDate: "",
      endDate: "",
      period: null,
      canDrag: true,
      searchName:""
    };
  },
  created: function() {},
  methods: {
    async init() {
      this.canDrag = true;
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.name = this.searchName;

      objdata.sortName = this.sortField;
      objdata.sortType = this.sortType;

      objdata.apiUrl = this.apiConfig.giftList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.gifts;
      this.setObj();
      this.total = data.data.result.total;
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 1;
      this.init();
    },
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    cell: function({ row }) {
      // if (!this.canDrag) {
      //   return "disabled pointer";
      // }
      // if (row.status == 1) {
      //   return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    handleDbClick: function(row) {
      this.$router.push({
        path: "/main/rewardDetail",
        query: {
          id: row.id
        }
      });
    },
    gotoDetail() {
      this.$router.push({ path: "/main/rewardDetail" });
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids.join(',');

      objdata.apiUrl = this.apiConfig.giftDelete;
      let data = await this.$store.dispatch("apiEventFromData", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
        this.init();
      }
    },
    setObj: function() {
      this.statusObj = [
        {
          value: "1",
          label: this.$i18n.t("message.Active")
        },
        {
          value: "0",
          label: this.$i18n.t("message.Inactive")
        }
      ];
      this.typeObj = [
        {
          value: 0,
          label: "Broadcast message"
        },
        {
          value: 1,
          label: "Promotion"
        }
      ];
      let list = null;
      for (list of this.rows) {
        if (list.status === 0) {
          list.statusName = this.$i18n.t("message.Inactive");
        } else if (list.status == 1) {
          list.statusName = this.$i18n.t("message.Active");
        }
      }
    },
    async updateNewsOrder(newIndex, oldIndex) {
      var item = this.rows[oldIndex];
      this.rows.splice(oldIndex, 1);
      this.rows.splice(newIndex, 0, item);
      let sortOrder = [];
      let objdata = this.getAuthObj();
      for (let i = 0; i < this.rows.length; i++) {
        sortOrder.push({
          id: this.rows[i].id,
          displayOrder: this.rows[i].sortOrder
        });
      }
      objdata.lstOrderDTO = sortOrder;

      objdata.apiUrl = this.apiConfig.giftOrder;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.init();
      
    }
  },
  mounted() {
    this.init();
    const table = document.querySelector(".el-table__body-wrapper tbody");
    var self = this;
    Sortable.create(table, {
      onEnd({ newIndex, oldIndex }) {
        self.updateNewsOrder(newIndex, oldIndex);
      },
      filter: ".disabled",
      onMove: event => {
        return !event.related.classList.contains("disabled");
      }
    });
  }
};
</script>
